import { useState } from 'react';
import '../../styles/Admin.css';
import api from '../../api/api';

export default function ForgotPassword() {

    const [email, setEmail] = useState('');
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        setError('');
        setSuccess('');

        try {

            await api.post('/forgot-password', {
                email
            });

            setSuccess(
                'If an account exists, a reset link has been sent.'
            );

        } catch {

            setError(
                'Unable to process request.'
            );

        }
    };

    return (
        <div className="admin-layout">
            <div className="admin-center">

                <div className="login-card">

                    <h2>Forgot Password</h2>

                    <p>
                        Enter your email to receive a password reset link.
                    </p>

                    {success && (
                        <div className="success-box">
                            {success}
                        </div>
                    )}

                    {error && (
                        <div className="error-box">
                            {error}
                        </div>
                    )}

                    <form
                        onSubmit={handleSubmit}
                        className="login-form"
                    >

                        <label>Email</label>

                        <input
                            type="email"
                            value={email}
                            onChange={(e) =>
                                setEmail(e.target.value)
                            }
                            required
                        />

                        <button
                            type="submit"
                            className="login-button"
                        >
                            Send Reset Link
                        </button>

                    </form>

                </div>

            </div>
        </div>
    );
}
